

export default {
    root: {
        transitionDuration: '{transition.duration}'
    },
    content: {
        //HACK: primeng was adding to 100% instead of subtracting in their code.  We may be able to remove this if/when they fix it
        //note, also change the 2 to .5 b/c it seemed to be too much space with 2
        width: "calc(100% - calc(.5 * var(--p-scrollpanel-bar-size)))" 
    },
    bar: {
        size: '9px',
        borderRadius: '{border.radius.sm}',
        focusRing: {
            width: '{focus.ring.width}',
            style: '{focus.ring.style}',
            color: '{focus.ring.color}',
            offset: '{focus.ring.offset}',
            shadow: '{focus.ring.shadow}'
        }
    },
    colorScheme: {
        light: {
            bar: {
                background: '{surface.700}'
            }
        },
        dark: {
            bar: {
                background: '{surface.700}'
            }
        }
    }
};
